import React from 'react';

export const Authenticating = () => <span id='oidcProvider_authenticatingComponent'></span>;
